
export default {
  data() {
    return {};
  },
};
